
export default {
  data() {
    return {};
  },
};
